import { Portal } from '@mantine/core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  padding: 5px 7px;
  flex-direction: column;
  align-items: stretch;

  .image {
    width: 60px;
    height: 60px;
  }

  .mat {
    width: 60px;
  }
`;

export const Top = styled.div`
  padding: 5px 5px 10px;
  border-bottom: 1px solid #336;
  margin-bottom: 10px;
  gap: 6px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .Segment-wrapper {
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Thumb = styled.div`
  cursor: pointer;
  border-radius: 10px;
  margin: 5px;
  filter: brightness(1.1) contrast(1.2);

  &:hover {
    background-color: #00000020;

    .title {
      opacity: 1;
    }
  }

  &.selected {
    background-color: #ffc0cb19;
  }
`;

export const Image = styled.div`
  background-size: contain;
  border-radius: 50%;

  &.loading {
    opacity: 0.5;
  }
`;

export const Title = styled.div`
  text-align: center;
  font-size: 11px;
  text-shadow: 0 0 3px #000;
  opacity: 0;
  transition: opacity 0.1s;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 60px;
  overflow: hidden;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;

  > div {
    overflow-x: hidden !important;
  }
`;

export const Filter = styled.div``;

export const Loading = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Categories = styled(Portal)`
  position: fixed;
  top: 25%;
  right: 263px;
  z-index: 2;
`;

const categoryColors = {
  all: '#FFFFFF', // Pure white for neutrality
  asphalt: '#FFD700', // Bright gold for high contrast
  concrete: '#00FFFF', // Cyan for a striking appearance
  fabric: '#FF69B4', // Hot pink for vibrancy
  floor: '#FFA500', // Bright orange for warmth
  gem: '#7B68EE', // Medium slate blue for richness
  glass: '#00CED1', // Dark turquoise for clarity
  ground: '#8B4513', // Saddle brown for earthiness
  leather: '#D2691E', // Chocolate for a leathery feel
  metal: '#B0C4DE', // Light steel blue for a metallic hint
  misc: '#ADFF2F', // Green yellow for uniqueness
  organic: '#32CD32', // Lime green for freshness
  plastic: '#FF4500', // Orange red for boldness
  rock: '#A9A9A9', // Dark gray for solidity
  roof: '#DC143C', // Crimson for prominence
  sand: '#FFDAB9', // Peach puff for a sandy tone
  sciFi: '#00FF7F', // Spring green for a futuristic vibe
  stone: '#C0C0C0', // Silver for a stony sheen
  vegetation: '#7FFF00', // Chartreuse for lushness
  wall: '#FF6347', // Tomato for a warm appearance
  wood: '#DEB887', // Burly wood for authenticity
};

export const Category = styled.div<{ category: keyof typeof categoryColors }>`
  min-width: 120px;
  background-color: var(--panels-bk-color);
  border-radius: 10px 10px 0 0;
  color: #333;
  font-weight: bold;
  text-align: center;
  font-size: 14px;
  opacity: 0.95;
  position: absolute;
  bottom: 0;
  left: 100px;
  // rotate 90deg
  z-index: 999999;
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.5), 0 0 8px 3px rgba(0, 0, 0, 0.05);

  color: ${({ category }) => categoryColors[category]};
`;
